import { render, staticRenderFns } from "./policy-hot-handle.vue?vue&type=template&id=1b4f434d&scoped=true&"
import script from "./policy-hot-handle.vue?vue&type=script&lang=js&"
export * from "./policy-hot-handle.vue?vue&type=script&lang=js&"
import style0 from "./policy-hot-handle.vue?vue&type=style&index=0&id=1b4f434d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f434d",
  null
  
)

export default component.exports